import { useTranslation } from '../../i18n';

const ScheduleActivityNestedOptionsLabel = () => {
  const { t } = useTranslation();

  return t('SCHEDULE');
};

export default ScheduleActivityNestedOptionsLabel;
